import React from 'react';
import { FormattedMessage } from 'react-intl';
import messages from '../../messages';

const name = <FormattedMessage {...messages.allocatedColumnHeader} />;

export default {
  getMessageDescriptor: () => messages.allocatedColumnHeader,
  name,
  render: (data, { isExpanded = false, isFirstRow = true, allData = [] }) => {
    if (!isExpanded && isFirstRow && Array.isArray(allData) && allData.length > 1) {
      return allData.reduce((acc, value) => acc + (value?.allocated || 0), 0);
    }
    return data.allocated || 0;
  },
};
